export default [
    { value: "Valorem", text: "Valorem", variante: "valorem-dourado", claims: ['Valorem'] },
]